// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ba3d8e7","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-tcfe-app/src/css"],"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/templates/products/uob-lmtedu-2024-internal-canvas-bag.vue
// module id = 844
// module chunks = 0